module.exports = __webpack_public_path__ + "static/media/spinner.5dee9102.svg";